import {
    RECEIVE_CONFIG,
    FETCH_ERROR,
    IS_LOADING,
} from "../actions/paymentActions";
import { PaymentState } from '../state/paymentState'

const initState: PaymentState = {
    loading: false,
    fetchError: false,
    paymentGateway: {
        CODE: "",
        description: "",
        id: "0",
        enabled: "",
        label: "",
        name: ""
    }
};

const PaymentReducer = (state: PaymentState = initState, action) => {
    switch (action.type) {
        case RECEIVE_CONFIG: {
            return {
                ...state,
                paymentGateway: action.payload,
                loading: false,
                fetchError: false
            }
        }
        case FETCH_ERROR: {
            return {
                ...state,
                fetchError: true,
                loading: false
            }
        }
        case IS_LOADING: return {
            ...state,
            loading: action.payload
        }

        default: return state;
    }
}

export default PaymentReducer;
